export const CREATING_REVIEW = "CREATING_REVIEW";
export const FETCHING_REVIEW = "FETCHING_REVIEW";
export const UPDATING_REVIEW = "UPDATING_REVIEW";
export const FEATURE_REVIEW = "FEATURE_REVIEW";
export const RESENDING_REVIEW = "RESENDING_REVIEW";
export const FETCHING_REVIEW_LOCATION = "FETCHING_REVIEW_LOCATION";
export const UPDATING_ORGANIC_REVIEW = "UPDATING_ORGANIC_REVIEW";


// WEBPACK FOOTER //
// ./src/screens/reviews/redux/types.js